module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10182.97420dde.jpg";